module.exports = __webpack_public_path__ + "img/nodata.9a125fb9.jpg";